/**
 * Predictive Search component
 * 
 * @module predictive-search
 * @version 1.0.0
 * @extends HTMLElement
 */

 customElements.component = 'predictive-search';

 if(!customElements.get(customElements.component)) {
  class PredictiveSearch extends HTMLElement {

    connectedCallback() {
      if (this._initialized) return;
  
      this.input = this.querySelector('input[type="search"]');

      this.predictiveSearchResults = this.querySelector('#predictive-search');

      this.cleanIcon = this.querySelector('[data-search-clean]');

      if (!this.input || !this.predictiveSearchResults || !this.cleanIcon) return;
      this._initialized = true;
 
      this.input.addEventListener('input', window.theme.debounce.apply(event => {
        this.onChange(event);
      }, 300).bind(this));

      this.input.addEventListener('focus', this.onFocus.bind(this));

      this.addEventListener('blur', this.onFocusOut.bind(this));

      this.noResults = this.predictiveSearchResults.innerHTML;

      this.cleanIcon.addEventListener('click', () => {
        this.removedCaractere();
        this.onChange();
      })
    }
  
    /**
     * on Change
     * 
     * @returns {undefined}
     */
    onChange() {
      const searchTerm = this.input.value.trim();

      if (!searchTerm.length) {
        this.predictiveSearchResults.innerHTML = this.noResults;
        this.cleanIcon.style.display = 'none';
        return;
      }

      this.cleanIcon.style.display = 'block';
      this.getSearchResults(searchTerm);
    }
  
    /**
     * Get search results
     * 
     * @param {string} searchTerm Search Term
     * @returns {undefined}
     */
    getSearchResults(searchTerm) {
      const vendorFilter = this.querySelector('input[name="filter.p.vendor"]');
      let vendorQuery = '';
      if (vendorFilter && vendorFilter.value) {
        vendorQuery = `&filter.p.vendor=${encodeURIComponent(vendorFilter.value)}`;
      }

      fetch(`${window.predictive_search_url}?q=${encodeURIComponent(searchTerm)}${vendorQuery}&resources[type]=product,collection,article,page&resources[limit]=12&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const resultsMarkup = doc.querySelector('#shopify-section-predictive-search').innerHTML;
    
          return fetch(`/search?q=${searchTerm}&type=product${vendorQuery}`)
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok.');
              }
              return response.text();
            })
            .then(html => {
              const searchDoc = parser.parseFromString(html, 'text/html');
              const qtyElement = searchDoc.querySelector('.collection__qty');
    
              if (qtyElement) {
                const numberOfResults = parseInt(qtyElement.textContent.trim(), 10);
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = resultsMarkup;
                const placeholder = tempDiv.querySelector('span[data-search-count]');
    
                if (placeholder) {
                  placeholder.textContent = `(${numberOfResults})`;
                }
    
                this.predictiveSearchResults.innerHTML = tempDiv.innerHTML;
              } else {
                this.predictiveSearchResults.innerHTML = resultsMarkup;
              }
    
              this.open();
            })
            .catch(error => {
              console.error('Error fetching search results:', error);
              this.close();
            });
        })
        .catch((error) => {
          console.error('Error fetching predictive search results:', error);
          this.close();
        });
    }
  
    /**
     * Open predictive search
     * 
     * @returns {undefined}
     */
    open() {
      this.predictiveSearchResults.style.display = 'block';
      this.setAttribute('open', true);
    }

    /**
     * Close predictive search
     * 
     * @returns {undefined}
     */
    close() {
      this.predictiveSearchResults.style.display = 'none';
      this.removeAttribute('open');
    }

    /**
     * Get Query
     * 
     * @returns {string}
     */
    getQuery() {
      return this.input.value.trim();
    }

    /**
     * On Focus
     * 
     * @returns {undefined}
     */
    onFocus() {
      const searchTerm = this.getQuery();
  
      if (!searchTerm.length) {
        this.predictiveSearchResults.innerHTML = this.noResults;
        return;
      } 
  
      if (this.getAttribute('open') === 'true') {
        this.open();
      } else {
        this.getSearchResults(searchTerm);
      }
    } 

    removedCaractere(){
      const searchTerm = this.input.value.slice(0, -1);
      this.input.value = searchTerm;
    }

    /**
     * On Focus out
     * 
     * @returns {undefined}
     */
    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) {
          this.close();
        }          
      });
    }
    
  }
  
  customElements.define(customElements.component, PredictiveSearch);
}
